import React, { useState } from "react";
import ReactFullpage from "@fullpage/react-fullpage";
import RevirtClubLanding from "../components/RevirtClub/RevirtClubLanding";
import RevirtClubMid from "../components/RevirtClub/RevirtClubMid";
import WithTheHelpOf from "../components/WithTheHelpOf/WithTheHelpOf";
import Footer from "../components/Footer/Footer";

const anchors = [
  "first",
  "second",
  "third",
  "fourth",
  "fifth",
  "sixth"
];

const RevirtClub = () => {
    const [page, setPage] = useState('revirtclub');
  return (
    <ReactFullpage
      anchors={anchors}
      responsiveWidth={1199}
      scrollOverflow={true}
      normalScrollElements=".cred-description"
      navigation
      navigationTooltips={anchors}
      onLeave={(origin, destination, direction) => {}}
      render={({ state, fullpageApi }) => {
        return (
          <ReactFullpage.Wrapper>
            <RevirtClubLanding/>
            <RevirtClubMid/>
            <WithTheHelpOf page={page}/>
            <Footer page={page}/>
          </ReactFullpage.Wrapper>
        );
      }}
    />
  );
};

export default RevirtClub;
